import React from 'react';
import { useTheme } from 'styled-components';
import { ColorSet } from 'src/theme/colors';

interface Props {
  size?: number;
  color?: keyof ColorSet;
  style?: React.CSSProperties;
  className?: string;
}

// Filled check-circle (icon-park-solid:check-one) — a solid disc with a white check knockout.
// Marks the committed CONFIRMED / ACCEPTED states in the consequences step (ticket 7127, screens
// 15/18). Defaults to statusGreen.
export const CheckCircleSvg: React.FC<Props> = ({ size = 20, color = 'statusGreen', style, className }) => {
  const { colors } = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <circle cx="10" cy="10" r="9" fill={colors[color]} />
      <path
        d="M5.83333 10.2083L8.54167 12.9167L14.1667 7.08333"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
